var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 143,
    viewBox: "0 0 118 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1529_1893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62.6172 73.3362V112.629",
    stroke: "black",
    strokeWidth: 8.3655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5059 73.3362V112.629",
    stroke: "black",
    strokeWidth: 8.3655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.458 38.8604C19.458 38.8604 5.45217 45.8316 5.76904 53.5C6.02254 60.3445 20.0918 62.626 20.0918 62.626",
    stroke: "black",
    strokeWidth: 8.3655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3938 66.9988L34.668 71.4984C34.0976 78.026 32.1963 83.0327 27.1263 84.4269C19.965 86.645 14.0077 82.2722 14.0077 78.2795C14.0077 74.2869 15.909 76.1882 15.909 76.1882C15.909 76.1882 13.3106 74.5404 15.3386 72.3857C16.0991 71.5618 18.3172 72.3857 18.3172 72.3857C18.3172 72.3857 18.7608 70.1675 19.965 69.7239C20.7255 69.4704 22.5633 70.2943 22.5633 70.2943L28.4572 67.0622L28.3938 66.9988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4515 58.76C23.4515 58.76 23.9585 60.1542 23.4515 61.9287C22.9445 63.9567 21.8672 64.9074 21.8672 64.9074C20.4095 65.9847 20.156 68.0127 21.2334 69.4704C22.3108 70.928 24.3388 71.1815 25.7964 70.1041C25.7964 70.1041 28.7117 68.0761 29.789 63.4497C30.7397 59.4571 29.4722 56.2884 29.4722 56.2884C28.775 54.6406 26.9372 53.8167 25.226 54.4505C23.5783 55.1476 22.7544 56.9855 23.3882 58.6966L23.4515 58.76Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.1878 76.9487H61.1591C81.9461 76.9487 98.8672 60.091 98.8672 39.2406C98.8672 18.3902 81.9461 1.53247 61.1591 1.53247",
    fill: "#AA7C00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.6219 67.8226H78.9041C78.9041 67.886 83.4671 63.1329 83.4671 63.1329L90.375 63.0061L85.5585 67.8226H85.6219Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.4668 69.5971H76.4955C76.4955 69.6604 72.6297 72.0687 72.6297 72.0687L80.6783 71.4349L83.4668 69.5337V69.5971Z",
    fill: "#E7BB29"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.3184 23.3968L88.0936 22.9532C87.3331 21.1787 84.6714 17.1227 82.6434 14.9045L90.3751 15.5383C92.0229 17.693 94.1776 21.242 95.3184 23.3968Z",
    fill: "#F3E9A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1884 76.9487C33.3627 76.9487 16.4802 60.0662 16.4802 39.2406C16.4802 18.415 33.3627 1.53247 54.1884 1.53247C75.014 1.53247 91.8965 18.415 91.8965 39.2406C91.8965 60.0662 75.014 76.9487 54.1884 76.9487Z",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1884 76.9487C33.3627 76.9487 16.4802 60.0662 16.4802 39.2406C16.4802 18.415 33.3627 1.53247 54.1884 1.53247C75.014 1.53247 91.8965 18.415 91.8965 39.2406C91.8965 60.0662 75.014 76.9487 54.1884 76.9487Z",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.2257 39.2405C26.3031 9.26416 54.3149 7.74316 53.9346 7.74316C36.5699 7.74316 22.4373 21.8758 22.4373 39.2405C22.4373 56.6053 36.5699 70.7379 53.9346 70.7379C71.2994 70.7379 25.7327 69.0268 25.2257 39.2405Z",
    fill: "#A67705"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1886 70.9915C36.6531 70.9915 22.4377 56.7761 22.4377 39.2406C22.4377 21.7051 36.6531 7.48975 54.1886 7.48975C71.7241 7.48975 85.9395 21.7051 85.9395 39.2406C85.9395 56.7761 71.7241 70.9915 54.1886 70.9915Z",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1878 76.9487H61.1591C81.9461 76.9487 98.8672 60.091 98.8672 39.2406C98.8672 18.3902 81.9461 1.53247 61.1591 1.53247",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1602 1.53247H54.1889",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.2687 37.4661C99.2473 52.1057 97.5996 71.0548 92.7831 85.6944",
    stroke: "black",
    strokeWidth: 8.3655,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9298 25.3614C46.2039 20.1646 53.8723 22.9531 53.8723 22.9531C54.1258 22.5729 54.3793 22.1926 54.6328 21.8124C52.9851 19.721 50.7036 18.3901 48.1686 18.3901C44.4294 18.3901 41.1973 21.242 39.8664 25.3614H39.9298Z",
    fill: "#ECD559",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2945 29.7342C39.2945 36.0084 43.2871 41.015 48.2937 41.015C53.3003 41.015 53.1102 39.6841 54.758 37.5927C56.3423 35.5647 57.293 32.7762 57.293 29.7342C57.293 26.6922 56.5958 24.7276 55.3917 22.8264C55.2016 22.5095 54.9481 22.1926 54.758 21.8757C54.5045 22.256 54.251 22.5729 53.9975 23.0165C53.9975 23.0165 46.2657 20.228 40.055 25.4247C39.6113 26.7556 39.3578 28.2132 39.3578 29.7342H39.2945Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.3301 38.3532C54.4428 37.466 52.6683 35.8182 50.3868 35.438C47.7251 35.0577 45.3168 35.8816 44.5563 37.973C43.5423 40.6981 45.6971 43.9302 49.056 44.8175C50.6403 45.1977 52.4782 45.1343 54.0626 44.4372",
    fill: "#ECD559"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.3301 38.3532C54.4428 37.466 52.6683 35.8182 50.3868 35.438C47.7251 35.0577 45.3168 35.8816 44.5563 37.973C43.5423 40.6981 45.6971 43.9302 49.056 44.8175C50.6403 45.1977 52.4782 45.1343 54.0626 44.4372",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1597 29.7343C52.1597 32.7763 53.1103 35.5648 54.6947 37.5928C56.3424 39.6841 58.624 41.015 61.159 41.015C66.1022 41.015 70.1582 35.945 70.1582 29.7343C70.1582 23.5235 70.1582 29.1005 70.1582 28.7836C70.1582 28.7836 64.3911 22.1293 55.4552 22.763C55.0116 22.763 54.5046 22.8264 53.9976 22.9531C52.8568 24.8544 52.2231 27.1993 52.2231 29.7343H52.1597Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.7797 25.3615C58.4982 25.3615 56.6604 27.7063 56.6604 30.5582C56.6604 33.4101 58.4982 35.755 60.7797 35.755C63.0612 35.755 64.5822 33.4735 64.709 32.1426L61.0332 30.4315L64.5822 28.657C64.2654 27.0726 62.7444 25.2981 60.7164 25.2981L60.7797 25.3615Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.1684 24.5375C45.8869 24.5375 44.049 26.8824 44.049 29.7342C44.049 32.5861 45.8869 34.931 48.1684 34.931C50.4499 34.931 51.9709 32.6495 52.0977 31.3186L48.4219 29.6075L51.9709 27.833C51.654 26.2486 50.133 24.4741 48.105 24.4741L48.1684 24.5375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.2807 117.889L55.7737 134.937L59.196 134.747L85.1163 134.937C85.1163 134.937 86.2571 126.381 81.504 122.135C76.6875 117.889 71.4273 118.079 68.1318 118.079C64.8363 118.079 56.2807 117.889 56.2807 117.889Z",
    fill: "#88CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3368 117.889L51.8438 134.937L48.4215 134.747L22.5011 134.937C22.5011 134.937 21.297 126.381 26.1135 122.135C30.93 117.889 36.1901 118.079 39.4856 118.079C42.7811 118.079 51.3368 117.889 51.3368 117.889Z",
    fill: "#88CAFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.1817 118.523C58.1817 118.523 56.0904 123.846 59.1957 129.043C62.2377 134.113 69.209 134.557 69.209 134.557L55.7735 134.747L56.2805 117.889L58.1817 118.523Z",
    fill: "#4A97CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.4355 118.523C49.4355 118.523 51.5269 123.846 48.4215 129.043C45.3795 134.113 38.4083 134.557 38.4083 134.557L51.8438 134.747L51.3368 117.889L49.4355 118.523Z",
    fill: "#4A97CC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.15 90.9545L102.037 89.4335C104.129 88.166 105.46 87.5956 106.537 88.3561L107.297 87.8491C107.297 87.8491 106.41 84.9972 107.614 83.9198C111.037 80.8145 113.065 84.8071 113.065 84.8071C113.065 84.8071 116.297 83.9198 116.55 87.152C116.677 89.3701 117.628 96.9751 107.868 101.538C94.8759 107.622 85.8767 93.8063 86.5738 91.5882C86.5738 91.5882 96.3969 95.9611 101.277 90.8277L101.15 90.9545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8273 117.699C68.8273 117.699 63.5672 119.98 57.2297 118.206C55.5185 117.699 54.5045 115.924 54.9482 114.213C55.3918 112.502 57.2297 111.488 58.9408 111.932C62.9968 113.072 66.2923 111.678 66.2923 111.678C67.94 110.981 69.8413 111.742 70.5384 113.389C71.2355 115.037 70.475 116.938 68.8273 117.635V117.699Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5764 18.8338C44.9353 19.0873 48.3575 17.186 49.625 14.9045",
    stroke: "black",
    strokeWidth: 3.73912,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.3996 117.699C51.3996 117.699 46.2028 119.98 39.8019 118.206C38.0908 117.699 37.0768 115.924 37.5204 114.213C37.9641 112.502 39.8019 111.488 41.5131 111.932C45.5691 113.072 48.8646 111.678 48.8646 111.678C50.5123 110.981 52.4136 111.742 53.1107 113.389C53.8078 115.037 53.0473 116.938 51.3996 117.635V117.699Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.1858 85.8844C90.1858 85.8844 91.3265 86.835 93.1644 87.0251C95.1924 87.2153 96.5233 86.5181 96.5233 86.5181C98.0443 85.5041 100.009 85.9478 101.023 87.4054C102.037 88.9264 101.593 90.891 100.136 91.905C100.136 91.905 97.2838 93.933 92.5306 93.4894C88.4113 93.0458 85.9396 90.8276 85.9396 90.8276C84.6088 89.6235 84.482 87.5955 85.6228 86.2646C86.8269 84.9338 88.8549 84.807 90.1858 85.9478V85.8844Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.8225 136.584C54.8225 135.57 55.6464 134.747 56.6604 134.747H84.2285C85.2425 134.747 86.0664 135.57 86.0664 136.584V138.422C86.0664 139.436 85.2425 140.26 84.2285 140.26H56.6604C55.6464 140.26 54.8225 139.436 54.8225 138.422V136.584Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.7949 136.584C52.7949 135.57 51.9711 134.747 50.9571 134.747H23.3889C22.3749 134.747 21.5511 135.57 21.5511 136.584V138.422C21.5511 139.436 22.3749 140.26 23.3889 140.26H50.9571C51.9711 140.26 52.7949 139.436 52.7949 138.422V136.584Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8225 136.584C54.8225 135.57 55.6464 134.747 56.6604 134.747H84.2285C85.2425 134.747 86.0664 135.57 86.0664 136.584V138.422C86.0664 139.436 85.2425 140.26 84.2285 140.26H56.6604C55.6464 140.26 54.8225 139.436 54.8225 138.422V136.584Z",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.7949 136.584C52.7949 135.57 51.9711 134.747 50.9571 134.747H23.3889C22.3749 134.747 21.5511 135.57 21.5511 136.584V138.422C21.5511 139.436 22.3749 140.26 23.3889 140.26H50.9571C51.9711 140.26 52.7949 139.436 52.7949 138.422V136.584Z",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.1153 134.937C85.1153 134.937 86.8898 125.114 79.2848 120.297C72.5036 116.051 63.1875 117.825 59.2583 125.24",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5004 134.937C22.5004 134.937 20.7259 125.114 28.3309 120.297C35.1121 116.051 44.4282 117.825 48.3574 125.24",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.8367 134.937L56.3438 117.889",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8438 134.937L51.3368 117.889",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.086 90.9546C102.797 91.3982 105.269 93.1093 106.029 94.8838",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.205 95.5175C106.029 94.5668 108.881 93.6796 108.881 93.6796C109.895 92.9825 110.466 91.3347 110.466 90.0672C110.466 90.0672 110.022 87.5322 111.67 85.631C113.191 83.8565 115.916 84.9338 116.359 86.8985C116.866 89.18 116.676 94.4401 112.177 98.6228C105.396 104.96 95.6992 103.756 89.9954 98.0525C88.1576 96.2146 86.8901 93.5528 86.1929 91.0812",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 84.8704C111.669 82.9692 109.578 82.0819 108.057 83.4128C106.409 84.8704 106.979 86.6449 107.55 89.0532C108.12 91.2713 107.55 93.3627 107.106 94.3133",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.107 87.9126C107.107 87.9126 106.537 88.483 106.537 89.497C106.537 90.8278 106.03 92.539 105.143 93.6163",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.53 89.8137C102.607 88.9899 104.889 86.9619 106.727 88.6096",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3101 70.6111C21.613 73.2728 22.5636 76.9486 24.4648 78.7865",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6055 71.4983C34.4153 74.4135 33.2746 81.5115 29.0285 83.6663C25.7963 85.2507 21.5502 85.5042 18.7617 84.0465C15.9098 82.5889 13.6917 79.6737 14.0086 78.0259C14.2621 76.6317 15.4028 76.1247 16.6703 76.2514C18.5716 76.5049 19.7757 78.0893 20.9798 79.3568",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3242 77.5823C23.3242 77.5823 22.944 77.7724 22.8806 77.8358C22.5637 78.0259 22.3102 78.216 21.9933 78.4062C21.1695 79.0399 20.4723 79.737 19.8386 80.6243",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.846 76.1248C15.846 76.1248 14.8953 75.4911 14.6418 74.6038C14.2616 73.4631 14.7686 72.2589 15.9727 72.0054C18.6345 71.3083 22.437 74.8573 23.3242 77.1388",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5079 72.3223C17.5573 71.3083 19.1417 68.7099 21.6133 69.9774",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8296 55.4011C43.0338 58.253 47.7235 55.211 51.5894 55.4011C56.7861 55.6546 60.4619 58.5698 61.666 55.7813C53.6808 51.5986 45.6955 54.197 45.6955 54.197C45.0618 53.3731 44.6815 52.2957 44.4914 50.9648C42.2099 52.2957 41.2593 54.0702 41.8296 55.4011Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.4917 50.9649C44.6818 52.2958 45.0621 53.3731 45.6958 54.197C45.6958 54.197 53.6811 51.5986 61.6663 55.7814C62.6169 53.5633 58.7511 49.3171 51.6531 49.3171C48.5477 49.3171 46.1394 50.0143 44.4917 50.9649Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9351 22.9531C54.4421 22.8898 54.8857 22.8264 55.3927 22.763C64.3286 22.0659 70.0957 28.7836 70.0957 28.7836C69.7155 22.9531 65.8496 18.3901 61.1598 18.3901C56.4701 18.3901 56.3433 19.721 54.6956 21.8124C54.4421 22.1926 54.1886 22.5095 53.9351 22.9531Z",
    fill: "#ECD559",
    stroke: "black",
    strokeWidth: 0.950625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9551 20.7983C65.5962 20.5448 62.5542 18.1365 61.5402 15.7283",
    stroke: "black",
    strokeWidth: 3.73912,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1529_1893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 141.375,
    fill: "white",
    transform: "matrix(-1 0 0 1 117.5 0.8125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadCoin);
export default __webpack_public_path__ + "static/media/sad_coin.dccfe3a9c5db578e33ec8eee4a099cca.svg";
export { ForwardRef as ReactComponent };